import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EditCalendarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"edit_calendar"}/>
}
